import { Table, Tag } from "antd"
import React from "react"
import { useQuery } from "react-query"
import usePlatform from "contexts/platform/use-platform"
import { Link } from "react-router-dom"
import { DateDisplay } from "components/display/DateDisplay"
import { useConfigurationContext } from "contexts/configuration/context"
import { IPolicyStates } from "contexts/configuration/context"

export const Policies: React.FC<IPoliciesProps> = (props) => {
  const platform = usePlatform()
  const configuration = useConfigurationContext()

  const policiesQuery = useQuery(
    ["policies", props.clientID],
    () => platform.policyholders.getPolicies(props.clientID),
    {
      enabled: !!props.clientID && !!platform.token
    }
  )

  const columns = [
    {
      title: "Created",
      dataIndex: "dateCreated",
      key: "dateCreated",
      width: "16.67%",
      render: (date: string | null) =>
        date ? <DateDisplay date={date} /> : "-"
    },
    {
      title: "Reference ID",
      key: "policyReferenceID",
      width: "16.67%",
      render: (row: { policyReferenceID: string | null; id: string }) =>
        row.policyReferenceID ? (
          <Link to={`/policy/${row.id}`}>{row.policyReferenceID}</Link>
        ) : (
          "-"
        )
    },
    {
      title: "Cover Start Date",
      dataIndex: "coverStartDate",
      key: "coverStartDate",
      width: "16.67%",
      render: (date: string | null) =>
        date ? <DateDisplay date={date} /> : "-"
    },
    {
      title: "Cover End Date",
      dataIndex: "coverEndDate",
      key: "coverEndDate",
      width: "16.67%",
      render: (date: string | null) =>
        date ? <DateDisplay date={date} /> : "-"
    },
    {
      title: "Status",
      dataIndex: "policyStatus",
      key: "policyStatus",
      width: "16.67%",
      render: (text: IPolicyStates) => {
        const policyType =
          configuration?.policy?.state && configuration?.policy?.state[text]
        return policyType ? (
          <Tag color={policyType.color}>{policyType.tag.toUpperCase()}</Tag>
        ) : (
          "-"
        )
      }
    },
    {
      title: "Type",
      dataIndex: "policyType",
      key: "policyType",
      width: "16.65%"
    }
  ]

  return (
    <Table
      loading={policiesQuery.isLoading}
      dataSource={policiesQuery.data || []}
      columns={columns}
      rowKey="id"
      pagination={{ pageSize: 10 }}
      locale={{
        emptyText: "No policies found"
      }}
    />
  )
}

export interface IPoliciesProps {
  clientID: string
}
